import { observer } from 'src/utils/mobx-react';
import { FilterData, FilterKey, FilterWrapper } from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';
import React from 'react';

type CommandsPropsType = {
    commands: Record<string, unknown>
}

export const Commands = observer('Commands', (props:CommandsPropsType) => {
    return (
        <>
            <h5>Command</h5>
            <FilterWrapper>
                <div>
                    {Object.keys(props.commands).map(commandKey => {
                        return <FilterKey>{commandKey}</FilterKey>;
                    })}
                </div>
                <div>
                    {Object.values(props.commands).map(commandValue => {
                        return <FilterData>{JSON.stringify(commandValue)}</FilterData>;
                    })}
                </div>

            </FilterWrapper>
            {/*<Button size='small' onClick={() => {}}>Add new command</Button>*/}
        </>
    );
});
